const employmentHistory = [
  {
    startDate: "2023-10",
    endDate: "Current",
    position: "Frontend Developer",
    companyName: "Skite Technologies, Ibadan",
    workDone: [
      // "Use regulatory and compliance standards for user interface designs.",
      // "Coded using HTML, CSS, JavaScript and React to develop features for both mobile and desktop platforms.",
      // "Successfully integrated a RESTful API into the frontend project,enabling real-time data retrieval and improved user experience.",
      // "Utilized React and Axios library to make API requests and implemented robust error handling for seamless data retrieval.",
      // "Collaborated with the backend development team to ensure seamless API communication and implemented user authentication using JWT tokens and Session Storage.",
      "I work on several apps mainly dedicated to administrative/management operations, using many different technologies and playing several roles.",
      "I am involved in most of the company projects, from inception to final delivery, helping gathering requirements, and driving the execution and delivery roadmaps.",
    ],
    techStack: [
      "TypeScript",
      "React",
      "VS Code",
      "Sass",
      "Google Cloud Platform",
    ],
  },
  {
    startDate: "2022-08",
    endDate: "2023-04",
    position: "Frontend Developer",
    companyName: "Gigmoni, Lagos",
    workDone: [
      // "Collaborated with stakeholders during development processes to confirm creative proposals and design best practices.",
      // "Analyzed project requirements, translating specifications into functional application components.",
      // "Redesigned sections of websites to create user-friendly, visually appealing experience.",
      // "Improved coding of JavaScript and CSS to enhance user experience and functionality.",
      // "Performed user experience quality assurance testing to identify and remedy shortcomings.",
      // "Applied feedback from code review and implemented changes to meet standards.",
      "Worked as a front-end development engineer, where I focused on building UIs and intergrating APIs using ReactJS and JavaScript",
      "It was my first formal job as a software developer and I learnt a lot about Fintech solutions, web development and databases.",
    ],
    techStack: ["JavaScript", "React", "Nodejs", "CSS"],
  },
];

export default employmentHistory;
